const hasHboSubscription = (state = {}) => {
    const subscriptions = state.user && state.user.superhighlight;

    return Array.isArray(subscriptions) && subscriptions.includes('suscripto_hbo');
};

export default hasHboSubscription;


// WEBPACK FOOTER //
// ./src/utils/user/hasHboSubscription.js